export default [
  {
    path: '/article/article/list',
    name: 'article-list',
    component: () =>
      import('@/views/pages/article/article-list/ArticleList.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Article Management',
      },
      {
        text: 'Article List',
        active: true,
      },
    ],
  },
  {
    path: '/article/article/create',
    name: 'create-article',
    component: () =>
      import('@/views/pages/article/article-info/CreateArticle.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Article Management',
      },
      {
        text: 'Article List',
        to: '/article/article/list'
      },
      {
        text: 'Add Article',
        active: true
      }
    ],
  },
  {
    path: '/article/article/:id/info',
    name: 'article-info',
    component: () =>
      import('@/views/pages/article/article-info/ArticleInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Article Management',
      },
      {
        text: 'Article List',
        to: '/article/article/list'
      },
      {
        text: 'Article Info',
        active: true
      }
    ],
  },
  {
    path: '/article/article/category',
    name: 'article-category',
    component: () =>
      import('@/views/pages/article/article-category/ArticleCategory.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Article Management',
      },
      {
        text: 'Article Category',
        active: true
      }
    ],
  },
  {
    path: '/article/article/category/create',
    name: 'create-article-category',
    component: () =>
      import('@/views/pages/article/article-category-info/CreateArticleCategory.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Article Management',
      },
      {
        text: 'Article Category',
        to: '/article/article/category'
      },
      {
        text: 'Add Category',
        active: true
      }
    ],
  },
  {
    path: '/article/article/category/:id/info',
    name: 'article-category-info',
    component: () =>
      import('@/views/pages/article/article-category-info/ArticleCategoryInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Article Management',
      },
      {
        text: 'Article Category',
        to: '/article/article/category'
      },
      {
        text: 'Category Info',
        active: true
      }
    ],
  }
]